import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { FixtureListItem } from "../CreateRound/CreateRoundModels";
import FixtureChooser from "../CreateRound/FixtureChooser";

interface ChooseFixtureDialogProps {
    openLabel?: string;
    onClose: (fixture: FixtureListItem | undefined) => void;
    disabled?: boolean;
}

const ChooseFixtureDialog: React.FC<ChooseFixtureDialogProps> = (props) => {
    const [open, setOpen] = useState<boolean>(false);

    const handleClose = () => {
        setOpen(false);
        props.onClose(undefined);
    };
    const onAdd = (fixture: FixtureListItem) => {
        setOpen(false);
        props.onClose(fixture);
    };

    var openLabel = props.openLabel && props.openLabel.length > 0 ? props.openLabel : "Choose Fixture";
    return (
        <div>
            <Button onClick={() => setOpen(true)} variant="outlined" color="secondary" size="small" disabled={props.disabled}>
                {openLabel}
            </Button>
            <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth aria-labelledby="choose-fixture-dialog-title">
                <DialogTitle id="choose-fixture-dialog-title">Choose Fixture</DialogTitle>
                <DialogContent dividers>
                    <FixtureChooser maxFixtures={1} onAdd={onAdd} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ChooseFixtureDialog;
